export const COLORS = {
  green: {
    text: 'text-green',
    bg: 'bg-green text-white',
    outline: 'text-green border border-green',
    hover: 'hover:bg-green-dark hover:text-white',
  },
  orange: {
    text: 'text-orange',
    bg: 'bg-orange text-white',
    outline: 'text-orange border border-orange',
    hover: 'hover:bg-orange-dark hover:text-white',
  },
  red: {
    text: 'text-red',
    bg: 'bg-red text-white',
    outline: 'text-red border border-red',
    hover: 'hover:bg-red-dark hover:text-white',
  },
  blue: {
    text: 'text-blue',
    bg: 'bg-blue text-white',
    outline: 'text-blue border border-blue',
    hover: 'hover:bg-blue-dark hover:text-white',
  },
  griege: {
    text: 'text-griege',
    bg: 'bg-griege text-white',
    outline: 'text-griege border border-griege',
    hover: 'hover:bg-griege-dark hover:text-white',
  },
  black: {
    text: 'text-[#494949]',
    bg: 'bg-[#494949] text-white',
    outline: 'text-[#494949] border border-[#494949]',
    hover: 'hover:bg-[#2f2f2f] hover:text-white',
  },
};
